import { render, staticRenderFns } from "./guiderAccountAppealAudit.vue?vue&type=template&id=6ffbf2b2&scoped=true&"
import script from "./guiderAccountAppealAudit.vue?vue&type=script&lang=js&"
export * from "./guiderAccountAppealAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbf2b2",
  null
  
)

component.options.__file = "guiderAccountAppealAudit.vue"
export default component.exports